import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreSetupAuditTrailSlice } from './get';

import { coreDataSecurityAuditTrailExportReducers, coreDataSecurityAuditTrailExportWatchers } from './export';
import { coreDataSecuritySetupAuditTrailGraphReducers, coreDataSecuritySetupAuditTrailGraphWatchers } from './graph';
import { coreSetupAuditTrailSectionsReducers, coreSetupAuditTrailSectionsWatchers } from './sections';
import {
	coreSetupAuditTrailSourceNamePrefixReducers,
	coreSetupAuditTrailSourceNamePrefixWatchers
} from './source-name-prefix';
import {
	coreSetupAuditTrailViewsReducers,
	coreSetupAuditTrailViewsWatchers
} from './views';

export const coreDataSecuritySetupAuditTrailReducers = combineReducers({
	export: coreDataSecurityAuditTrailExportReducers,
	get: getCoreSetupAuditTrailSlice.asyncReducers,
	graph: coreDataSecuritySetupAuditTrailGraphReducers,
	sections: coreSetupAuditTrailSectionsReducers,
	sourceNamePrefix: coreSetupAuditTrailSourceNamePrefixReducers,
	views: coreSetupAuditTrailViewsReducers
});

export const coreDataSecuritySetupAuditTrailWatchers = combineAllWatchers([
	coreDataSecurityAuditTrailExportWatchers,
	coreDataSecuritySetupAuditTrailGraphWatchers,
	coreSetupAuditTrailSectionsWatchers,
	coreSetupAuditTrailSourceNamePrefixWatchers,
	coreSetupAuditTrailViewsWatchers,
	getCoreSetupAuditTrailSlice.asyncWatchers
]);
